import { render, staticRenderFns } from "./StudioShot.vue?vue&type=template&id=000b0bee&lang=html"
import script from "./StudioShot.vue?vue&type=script&lang=js"
export * from "./StudioShot.vue?vue&type=script&lang=js"
import style0 from "./StudioShot.vue?vue&type=style&index=0&id=000b0bee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports